/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";
import { loginUser, receiveToken, doInit } from '../actions/auth';
import axios from 'axios';

import { Tooltip } from 'reactstrap';

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      username: '',
      password: '',
      tooltipOpen:false,
      tooltipPasswordOpen: false,
      openOrderRequested: false,
      order_status:"accepted"
    };

  }
  setOpenOrderRequested = (value)=>{
    this.setState({openOrderRequested: value})
  }
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;

    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');
    var bodyFormData = new FormData();
    bodyFormData.append('token', token);
    console.log("fetechstatus");
    axios.post(`/quotes/fetchstatus`, bodyFormData).then(res => {
      console.log('res.data',res.data)
      if(res.data.status == "success")
        var quote = res.data.data
        if(quote){
          if((quote.order_status && (quote.order_status.includes("Completed") || quote.order_status.includes("Requested")))){
            this.setState({order_status: "accepted"})
          }
          else{
            this.setState({order_status: false})
          }
        }
    })

  }
  doAccept=(e)=>{
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');
    var bodyFormData = new FormData();
    bodyFormData.append('token', token);
    axios.post(`/quotes/accept`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        this.setState({order_status: "accepted"})
        this.setOpenOrderRequested(true); return;
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })

  }
  changeEmail=(event)=> {
    this.setState({ email: event.target.value });
  }

  changeUsername=(event)=> {
      this.setState({ username: event.target.value });
  }

  changePassword=(event)=> {
      this.setState({ password: event.target.value });
  }

  
  toggleToolTip = () => this.setState({tooltipOpen:!this.state.tooltipOpen});
  toggleToolTipPassword = () => this.setState({tooltipPasswordOpen:!this.state.tooltipPasswordOpen});
  render() {
    return (
      <>
        <DemoNavbar />
        <main ref="main" className="login-page">
          <img className="login-bg" width="100%" src={require("assets/img/bg-1.jpg").default}/>
          <section className="section section-shaped section-lg">
            <div className="">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>
            <Container className="pt-lg-7">
              <Row className="justify-content-center">
                <Col lg="5">
                  <Card className="bg-white shadow border-0 login-card">
                    
                    <CardBody className="px-lg-5 py-lg-5">
                      <div className="text-center text-muted mb-1">
                        <img width="80px" src={require("assets/img/brand/logo_small.png").default}/><br/>
                        <span style={{color:'black', fontSize:16}}><b>Are you sure to accept your quote?</b></span>
                      </div>
                      <Form role="form" className="mt-4">                        
                        <div className="text-center">
                          <Button
                            className="mb-2 w-100 rounded-0 login-btn"
                            color="primary"
                            type="button"
                            onClick={this.doAccept}
                            disabled = {this.state.order_status == "accepted"}
                          >
                            Accept
                          </Button>
                          
                        </div>
                      </Form>
                      
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="7" className="d-flex align-items-center justify-content-center">
                  <div>
                    <h1><b>Congratulations</b></h1>
                    <h3><b>Welcome to your</b><br/><b>Online Ordering Portal</b></h3>
                    <p>
                      Your business has qualified to use our custom online ordering portal.<br/>
                      Should you have any questions feel free to contact the team
                    </p>
                    <div className="d-flex align-items-center">
                      <a href="tel:0397865005" className="mr-2"><b>03 9786 5005</b></a>
                      <a href="mailto:team@bigbranding.com.au"><b> - team@bigbranding.com.au</b></a>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
        <Modal isOpen={this.state.openOrderRequested} toggle={()=>this.setOpenOrderRequested(false)} >
          <ModalHeader toggle={()=>this.setOpenOrderRequested(false)}>Note</ModalHeader>
          <ModalBody>
            Your Order has been submitted and we will send you updates as the order progresses.
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" size="sm" onClick={()=>this.setOpenOrderRequested(false)}>Close</Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    loginUser: (email, password)=>dispatch(loginUser(email, password)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Login);
